<template>
  <el-dialog :title="dialogTitle" :visible.sync="open" :center="true" width="60%" @close="cancel"
    :close-on-click-modal="false">
    <div>
      <el-row>
        <el-col :span="6">
          <span>产品：{{ data.data?data.data[0].productName:'-' }}</span>
        </el-col>
        <el-col :span="6">
          <span>规格型号：{{data.data?data.data[0].specName:'-'}}</span>
        </el-col>
        <el-col :span="6">
          <span>批次号：{{data.data?data.data[0].batch:'-'}}</span>
        </el-col>
     
      </el-row>
      <div style="margin: 10px 0px">
         <el-button v-if="$route.query.formMode==1||$route.query.formMode==3" type="primary" class="btn primary" size="small" v-preventReClick @click="addEvt">新增</el-button>
    
        
      </div>
      <el-table :data="tableData" border style="width: auto; margin: 10px 0px" stripe :header-cell-style="{ background: '#DDEBFF' }"
        @selection-change="handleSelectionChange" row-key="index" max-height="400">
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55"> </el-table-column>
        <el-table-column type="index" width="50" label="序号"> </el-table-column>
         <el-table-column prop="productName" label="产品名称" min-width="100"></el-table-column>
        <el-table-column prop="serialNo" label="序列号" width="100">
          <template slot-scope="scope">
            <el-input v-if="scope.row.isAdd" v-model="scope.row.serialNo" ></el-input>
            <span v-else>{{scope.row.serialNo}}</span>
          </template>
        </el-table-column>
          <el-table-column  label="账面数量" width="100">
            <template slot-scope="scope">
              {{  scope.row.stockNumber }}
            </template>
          </el-table-column>
          <el-table-column  label="实盘数量" width="100">
            <template slot-scope="scope">
              <el-input v-model="scope.row.actualQuantity" ></el-input>
            </template>
          </el-table-column>
          
        <el-table-column  prop="operation" v-if="$route.query.formMode==1||$route.query.formMode==3" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if="scope.row.isAdd==0" v-preventReClick @click="editEvt(scope.row)" class="color-blue">编辑</el-button>
            <el-button type="text" size="small" v-if="scope.row.isAdd" v-preventReClick @click="confirmAdd(scope.row)" class="color-blue">确定</el-button>
            <el-button type="text" size="small" v-if="scope.row.isAdd" v-preventReClick @click="cancelAdd(scope.row,scope.$index)" class="color-blue">取消</el-button>
            <el-button type="text" size="small" v-if="scope.row.isAdd" v-preventReClick @click="delEvt(scope.row,scope.$index)" class="color-blue">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

        <div slot="footer" class="footer-bottom">
            <el-button size="small" @click="cancel">取消</el-button>
            <el-button type="primary" v-if="$route.query.formMode==1||$route.query.formMode==3" size="small" @click="confirm">确定</el-button>
        </div>
    </div>
  </el-dialog>
</template>


<script>
import {
  GetTagCodePrintData,
  GetTagCodeRfidPrintData
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin";

export default {
  mixins: [GetDataMixin],
  data () {
    return {
      dialogTitle: '个体详情',
      tableData:[],
      batchPrintType:'',
    }
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: {}
    },
  
  },
  created(){
    this.tableData = JSON.parse(JSON.stringify(this.$props.data.data)).map(item=>{
      if(!item.actualQuantity&&item.actualQuantity!=0){
        item.actualQuantity = item.stockNumber
      }
      return item
    })
  },
  mounted () {
    this.rfidSocketApi.init(this.onmessage, this.onopen);
  },
  beforeDestroy () {
    this.rfidSocketApi.clearBingMethods();
  },
  methods: {
    onmessage (e) {
      var data = JSON.parse(e.data);
      if (data.Successful) {
        this.$my_message("打印成功", "success");
      } else {
        this.$my_message("打印失败：" + data.Message, "error");
      }
    },
    onopen () {
      console.log("连接成功了哦");
    },
    editEvt(row){
      this.$set(row,'isAdd',1)
    },
    cancel () {      
      this.$emit('close');
    },
    cancelAdd(row){
      this.$set(row,'isAdd',0)
    },
    delEvt(row,index){
      this.$emit('del',row)
     this.tableData.splice(index, 1);
    },
    confirmAdd(row){
       this.$set(row,'isAdd',0)
      this.$emit('add',row)
    },
    confirm(){
      this.$emit('confirm',this.tableData)
    },
    addEvt(){
      let obj = JSON.parse(JSON.stringify(this.tableData[0]))
      obj.stockNumber = 0
      obj.serialNo = ''
      obj.isAdd = 1
      obj.actualQuantity = 0
      this.tableData.push(obj)
      
    },
     //普通打印
    print1 (row) {
      return new Promise((resolve, reject) => {
        let data = {
          tagCode: row.minTagCode,
          isSingle:row.isRfid==1?1:0
        }
        return GetTagCodePrintData(data).then((res) => {
          var result = res.returnData
          this.$set(row,'printTimes',row.printTimes+1)
          var printData = this.printDataConvert(result.printData)
          this.sendPrintMessage(JSON.stringify(printData));
          resolve(res.returnData);
        });
      });
    },
    print (row, notRefresh) {
      return new Promise((resolve, reject) => {
        return GetTagCodeRfidPrintData({
          tagCode: row.minTagCode,
        }).then((res) => {
          var action = "PrintSingle";
          if (row.isRfid != 1) {
            action = "PrintPack";
          }
           if(this.system_setting.RFIDTempSite){
            this.$my_message("打印成功", "success");
            his.$set(row,'printTimes',row.printTimes+1)
                resolve(res.returnData);
                return
            }

          var data = {
            Action: action,
            Content: res.returnData,
          };
          this.$set(row,'printTimes',row.printTimes+1)
          this.rfidSocketApi.sendSock(data);
          resolve(res.returnData);
        });
      });
    },
    batchPrintChange (num) {
      this.batchPrintType = num
      if (!this.multipleSelection) {
        this.$my_message("请选择要打印的数据", "warning");
        return;
      }
 

      const map = new Map();
      for (let i = 0; i < this.multipleSelection.length; i++) {
        if ("minTagCode" in this.multipleSelection[i]) {
          this.multipleSelection[i].minTagCode = this.multipleSelection[i].minTagCode;
        }
      }
      this.newArr = this.multipleSelection.filter(
        (key) => !map.has(key.minTagCode) && map.set(key.no, 1)
      );

      this.printForeach(0);
    },

    printForeach (i) {
      if (i != this.newArr.length) {
        let notRefresh = true;
        if (i == this.newArr.length - 1) {
          notRefresh = false;
        }
        if(this.batchPrintType==1){
          this.print(this.newArr[i], notRefresh).then((res) => {
            i++;
            setTimeout(() => {
              this.printForeach(i);
            }, 1000);
          });
        }else{
          this.print1(this.newArr[i], notRefresh).then((res) => {
            i++;
            setTimeout(() => {
              this.printForeach(i);
            }, 1000);
          });
        }
      
      } else {
        // this.getData()
      }
    },
  }
}
</script>